export const GET_STATISTICS_POPULAR_VICECAPTAINS = "GET_STATISTICS_POPULAR_VICECAPTAINS";
export const CLEAR_FILTERS_POPULAR_VICECAPTAINS = "CLEAR_FILTERS_POPULAR_VICECAPTAINS";